// TeamArea.js
import React from "react";
import TeamMember from "./TeamMember";
import teamData from "../../assets/data/teamData.json";

function TeamArea({ className }) {
  return (
    <section className={`team-area pt-115 pb-90 ${className}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-60">
              <span className="sub-title">Náš tým</span>
              <h2 className="title">Kontakty</h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {teamData.map((member) => (
            <TeamMember key={member.id} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamArea;
